import React, { FC, forwardRef } from 'react'
import {
    StyledContainer,
    StyledRowContainer,
    StyledInnerRowContainer,
    StyledCloseButton,
    StyledIconCross,
    StyledTextContainer,
    StyledTextLink,
    StyledInnerLinkRowContainer,
    StyledMessagesContainer,
} from './StickyAccountInnerBanner.styled'
import { useTheme } from '@emotion/react'
import { Product } from '@news-mono/web-common'

interface StickyAccountBannerLink {
    linkText: string
    onLinkClick: () => void
}

interface StickyAccountInnerBannerProps {
    isHidden: boolean
    messages: string[]
    onClose: () => void
    initialBannerText?: string
    links?: StickyAccountBannerLink[]
}

export const StickyAccountInnerBanner = forwardRef<
    HTMLDivElement,
    StickyAccountInnerBannerProps
>((props, ref) => {
    const theme = useTheme()
    return (
        <StyledContainer isHidden={props.isHidden} ref={ref}>
            <StyledRowContainer>
                <StyledInnerRowContainer>
                    <StyledCloseButton onClick={props.onClose}>
                        <StyledIconCross />
                    </StyledCloseButton>
                </StyledInnerRowContainer>
                <StyledInnerRowContainer hasGap>
                    <StickyAccountInnerBannerMessages
                        messages={props.messages}
                        links={props.links}
                        product={theme.kind}
                    />
                    <StickyAccountInnerBannerLinks
                        links={props.links}
                        product={theme.kind}
                    />
                </StyledInnerRowContainer>
            </StyledRowContainer>
        </StyledContainer>
    )
})

interface StickyAccountInnerBannerMessagesProps {
    messages: string[]
    product: Product
    links?: StickyAccountBannerLink[]
}

const StickyAccountInnerBannerMessages: FC<StickyAccountInnerBannerMessagesProps> =
    ({ messages, product, links }) => {
        if (!messages.length) {
            return null
        }

        return (
            <StyledMessagesContainer>
                {messages.map((message, index) => {
                    const link = links?.[index]

                    return (
                        <StyledTextContainer key={message}>
                            {message}
                            {product === 'perthnow' && !!link && (
                                <StyledTextLink
                                    onClick={link.onLinkClick}
                                    key={link.linkText}
                                >
                                    {link.linkText}
                                </StyledTextLink>
                            )}
                        </StyledTextContainer>
                    )
                })}
            </StyledMessagesContainer>
        )
    }

interface StickyAccountInnerBannerLinksProps {
    product: Product
    links?: StickyAccountBannerLink[]
}

const StickyAccountInnerBannerLinks: FC<StickyAccountInnerBannerLinksProps> = ({
    product,
    links,
}) => {
    if (product !== 'thenightly' || links?.length === 0) {
        return null
    }

    return (
        <StyledInnerLinkRowContainer>
            {links?.map((link) => {
                return (
                    <StyledTextLink
                        onClick={link.onLinkClick}
                        key={link.linkText}
                    >
                        {link.linkText}
                    </StyledTextLink>
                )
            })}
        </StyledInnerLinkRowContainer>
    )
}
